export default {
    name: 'fodboldpakker',
    address: 'Rosendal 1C, 2860 Søborg',
    shop_address: 'Fodboldpakker ApS Rosendal 1C 2860 Søborg',
    office_address: 'Fodboldpakker ApS Rosendal 1C 2860 Søborg',
    email: 'kundeservice@fodboldpakker.dk',
    email_no: 'kundeservice@fotballpakker.no',
    phone: '(+45) 71 74 18 92',
    emergencyPhone: '(+45) 71 74 18 92',
    workingHour: [
      { title: 'mon_to_fri', value: '09:00-15:00', translateValue: false },
      // { title: 'fri', value: '09.00-15.00', translateValue: false },
      { title: 'sat', value: '10.00-12.00 (kun telefon)', translateValue: false },
      { title: 'sun', value: 'closed', translateValue: true }
    ],
    holidayWorkingHours: {
      title: 'christmas_new_year',
      subtitle: 'after_christmas_new_year',
      hours: [
        {
          section: 'christmas_new_year',
          hours: [
            { date: 'dec_24_26', value: 'closed', translateValue: true, translateDate: true },
            { date: 'dec_27', value: 'phone_hours_10_14', translateValue: true, translateDate: true },
            { date: 'dec_28', value: 'phone_hours_10_12', translateValue: true, translateDate: true },
            { date: 'dec_29', value: 'closed', translateValue: true, translateDate: true },
            { date: 'dec_30', value: 'phone_hours_10_14', translateValue: true, translateDate: true },
            { date: 'dec_31_jan_1', value: 'closed', translateValue: true, translateDate: true }
          ]
        },
        {
          section: 'after_christmas_new_year',
          hours: [
            { title: 'mon_to_fri', value: '07:00-15:00', translateValue: false },
            { title: 'sat', value: 'phone_hours_10_12', translateValue: true },
            { title: 'sun', value: 'closed', translateValue: true }
          ]
        }
      ]
    },
    cvr: 41967218,
    travelGuaranteeFundNumber: 3350
  }
